import React, { useState } from 'react';
import { Client } from '../../types/api';
import { ClientList } from './ClientList';
import { ClientModal } from './ClientModal';

export const ClientManagement: React.FC = () => {
  const [showClientModal, setShowClientModal] = useState(false);
  const [editingClient, setEditingClient] = useState<Client | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleCreateClient = () => {
    setEditingClient(null);
    setShowClientModal(true);
  };

  const handleEditClient = (client: Client) => {
    setEditingClient(client);
    setShowClientModal(true);
  };

  const handleCloseModal = () => {
    setShowClientModal(false);
    setEditingClient(null);
  };

  const handleSaveClient = (savedClient: Client) => {
    setShowClientModal(false);
    setEditingClient(null);
    // Trigger refresh of client list
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <>
      <ClientList
        refreshTrigger={refreshTrigger}
        onCreateClient={handleCreateClient}
        onEditClient={handleEditClient}
      />

      <ClientModal
        client={editingClient}
        isOpen={showClientModal}
        onClose={handleCloseModal}
        onSave={handleSaveClient}
      />
    </>
  );
};